var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#476a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.732 1A4.74 4.74 0 0 0 1.86 3H3a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 1 0v1.483a5.75 5.75 0 1 1-.816 4.78A.5.5 0 0 1 1.149 7a4.75 4.75 0 1 0 4.584-6M6 2.5a.5.5 0 0 0-1 0v3.35a.8.8 0 0 0 .32.64L7.2 7.9a.5.5 0 0 0 .6-.8L6 5.75z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "476a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
});
const SvgHistorysmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistorysmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3MV8yMjE3KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS43MzI0NiAxQzQuMTM0NTcgMSAyLjcyMDMyIDEuNzg4ODggMS44NTg5MiAzSDNDMy4yNzYxNCAzIDMuNSAzLjIyMzg2IDMuNSAzLjVDMy41IDMuNzc2MTQgMy4yNzYxNCA0IDMgNEgwLjVDMC4yMjM4NTggNCAwIDMuNzc2MTQgMCAzLjVWMUMwIDAuNzIzODU4IDAuMjIzODU4IDAuNSAwLjUgMC41QzAuNzc2MTQyIDAuNSAxIDAuNzIzODU4IDEgMVYyLjQ4MzI3QzIuMDM3MDkgMC45ODM2NTMgMy43Njk1OSAwIDUuNzMyNDYgMEM4LjkwODA5IDAgMTEuNDgyNSAyLjU3NDM2IDExLjQ4MjUgNS43NUMxMS40ODI1IDguOTI1NjQgOC45MDgwOSAxMS41IDUuNzMyNDYgMTEuNUMzLjA3OTggMTEuNSAwLjg0Nzg2MiA5LjcwNDE3IDAuMTgzNjc3IDcuMjYyODRDMC4xMTExODUgNi45OTYzOCAwLjI2ODQyNSA2LjcyMTYxIDAuNTM0ODgzIDYuNjQ5MTFDMC44MDEzNCA2LjU3NjYyIDEuMDc2MTEgNi43MzM4NiAxLjE0ODYgNy4wMDAzMkMxLjY5NzM4IDkuMDE3NDQgMy41NDI0MiAxMC41IDUuNzMyNDYgMTAuNUM4LjM1NTgxIDEwLjUgMTAuNDgyNSA4LjM3MzM1IDEwLjQ4MjUgNS43NUMxMC40ODI1IDMuMTI2NjUgOC4zNTU4MSAxIDUuNzMyNDYgMVpNNS45OTk5OCAyLjVDNS45OTk5OCAyLjIyMzg2IDUuNzc2MTIgMiA1LjQ5OTk4IDJDNS4yMjM4NCAyIDQuOTk5OTggMi4yMjM4NiA0Ljk5OTk4IDIuNVY1Ljg1QzQuOTk5OTggNi4xMDE4MSA1LjExODUzIDYuMzM4OTIgNS4zMTk5OCA2LjQ5TDcuMTk5OTggNy45QzcuNDIwODkgOC4wNjU2OSA3LjczNDI5IDguMDIwOTEgNy44OTk5OCA3LjhDOC4wNjU2NiA3LjU3OTA5IDguMDIwODkgNy4yNjU2OSA3Ljc5OTk4IDcuMUw1Ljk5OTk4IDUuNzVWMi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjcxXzIyMTciPgo8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";